import { ArrowRight, CheckCircle } from "@phosphor-icons/react";
import React, { FC } from "react";
import { motion } from "framer-motion";
import { useAccountSetupMetric } from "./CompleteSetupTaskList";

const FinishModal: FC<{
  finishSetupModalOpen: boolean;
  setFinishSetupModaOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ setFinishSetupModaOpen }) => {
  const metric = useAccountSetupMetric();

  return (
    <div
      onClick={() => setFinishSetupModaOpen(true)}
      className="col-span-full bg-white drop-shadow-sm p-5 rounded-xl flex flex-col gap-4 cursor-pointer"
    >
      <div className="flex items-start md:items-center gap-4">
        <div className="text-visaro-orange">
          <CheckCircle weight="fill" size={42} />
        </div>
        <div className="flex-1">
          <div className="font-medium text-lg">
            Finish setting up your account
          </div>
          <div className="text-gray-500">
            You’re on a good start! Unlock secure payments, instant credit, and
            more.
          </div>
        </div>
        <div className="p-2 bg-gray-100 rounded-full hover:scale-105 transition-all cursor-pointer">
          <ArrowRight weight="bold" size={18} />
        </div>
      </div>
      <div className="flex gap-4 items-center">
        <div className="flex flex-col flex-1 gap-2">
          <div className="h-2 rounded bg-gray-200 w-full">
            <motion.div
              animate={{
                width: `${((metric.done / metric.all) * 100).toFixed(0)}%`,
              }}
              className="h-full rounded bg-visaro-orange"
            ></motion.div>
          </div>
          <div className="text-gray-500 text-sm">
            {((metric.done / metric.all) * 100).toFixed(0)}% complete
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinishModal;
